import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function About() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-20 pb-12">
        <div className="px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb items={[{ label: '关于我们' }]} />

            {/* Page Header */}
            <header className="mb-12">
              <h1 className="text-2xl md:text-4xl font-bold font-heading text-foreground-100 mb-3">
                关于 <span className="text-accent-500">51视频</span>
              </h1>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                蓝光4K超清 · 无广告 · 不缓冲 · 免费在线观看
              </p>
            </header>

            {/* Brand Introduction */}
            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-100 mb-6">
                品牌介绍
              </h2>
              <div className="p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/50">
                <p className="text-sm md:text-base text-foreground-200 leading-relaxed mb-4">
                  51视频成立于2024年，是一家专注于高清视频资源聚合的在线平台。我们致力于为广大影音爱好者提供最优质的观影体验——蓝光4K超清画质、全程无广告干扰、播放流畅不缓冲，所有内容完全免费。
                </p>
                <p className="text-sm md:text-base text-foreground-200 leading-relaxed mb-4">
                  平台汇集了<strong className="text-foreground-100">蓝莓视频</strong>、<strong className="text-foreground-100">糖心视频</strong>、<strong className="text-foreground-100">黑桃视频</strong>、<strong className="text-foreground-100">妖精视频</strong>四大品牌频道，以及动作、剧情、喜剧、悬疑、爱情、科幻、纪录等多个分类，涵盖了从最新大片到经典老片的海量内容库。无论您是动作片爱好者、文艺片发烧友还是纪录片控，都能在这里找到心头好。
                </p>
                <p className="text-sm md:text-base text-foreground-200 leading-relaxed">
                  我们相信，好的观影体验不应该被广告打断，高清画质不应该是付费用户的特权。51视频的使命就是让每一位用户都能享受到纯净、流畅、高清的在线观影体验。
                </p>
              </div>
            </section>

            {/* Core Values */}
            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-100 mb-6">
                核心优势
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 mb-3">
                    <i className="ri-4k-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-100 mb-2">真4K蓝光画质</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    所有视频均采用原生4K片源，支持HDR高动态范围和杜比视界。3840×2160分辨率带来4倍于1080P的像素密度，每一帧画面都细腻如壁纸。
                  </p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 mb-3">
                    <i className="ri-forbid-2-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-100 mb-2">纯净零广告</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    全程无任何形式的广告插入，包括片头广告、片中弹窗、暂停广告等。我们承诺：观影过程中您不会看到任何商业推广内容。
                  </p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 mb-3">
                    <i className="ri-speed-up-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-100 mb-2">流畅不缓冲</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    自研P2P-CDN混合加速技术，在全国部署超过3000个加速节点。智能码率调节算法实时适应网络波动，确保播放始终流畅。
                  </p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 mb-3">
                    <i className="ri-global-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-100 mb-2">海量内容库</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    超过10万+高清视频资源，覆盖12大分类，每日持续更新。从院线大片到小众佳作，从经典老片到最新上线，应有尽有。
                  </p>
                </div>
              </div>
            </section>

            {/* Brand Channels */}
            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-100 mb-6">
                品牌频道
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/50">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10">
                      <i className="ri-movie-line text-xl text-accent-500"></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-100">蓝莓视频</h3>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    主打科幻、动作类大片，沉浸式观影体验，特效视觉震撼。蓝光4K极致画质，让您感受大银幕般的震撼。
                  </p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/50">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10">
                      <i className="ri-heart-line text-xl text-accent-500"></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-100">糖心视频</h3>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    聚焦悬疑、剧情类精品，烧脑剧情引人入胜。精选优质内容，每一部都值得用心品味。
                  </p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/50">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10">
                      <i className="ri-vip-diamond-line text-xl text-accent-500"></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-100">黑桃视频</h3>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    武侠、动作类影视内容，展现中国功夫与传统文化的魅力。刀光剑影间的美学盛宴。
                  </p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/50">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10">
                      <i className="ri-magic-line text-xl text-accent-500"></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-100">妖精视频</h3>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    爱情、喜剧、纪录片等多种类型，轻松愉悦的观影选择。发现生活中的美好与感动。
                  </p>
                </div>
              </div>
            </section>

            {/* User Reviews */}
            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-100 mb-6">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/50">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-sm text-accent-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-300 leading-relaxed mb-3">
                    "画质真的太好了，4K蓝光清晰度秒杀其他平台。而且真的没有广告，观影体验一级棒！"
                  </p>
                  <div className="text-xs text-foreground-500">— 用户张先生 · 2026年7月</div>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/50">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-sm text-accent-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-300 leading-relaxed mb-3">
                    "之前用其他平台看4K一直缓冲，51视频确实流畅，说是不缓冲就真的不缓冲，体验太好了。"
                  </p>
                  <div className="text-xs text-foreground-500">— 用户李女士 · 2026年7月</div>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/50">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-sm text-accent-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-300 leading-relaxed mb-3">
                    "片源很全，分类也很清晰，想看的电影基本都能找到。真心推荐给所有电影爱好者！"
                  </p>
                  <div className="text-xs text-foreground-500">— 用户王先生 · 2026年6月</div>
                </div>
              </div>
            </section>

            {/* FAQ */}
            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-100 mb-6">
                常见问题
              </h2>
              <div className="flex flex-col gap-3">
                {[
                  {
                    q: '51视频真的完全免费吗？',
                    a: '是的，51视频所有内容完全免费，无需注册，无需会员，打开即可观看。我们通过其他方式维持运营，不向用户收费。',
                  },
                  {
                    q: '真的没有任何广告吗？',
                    a: '我们承诺全程无广告，包括片头广告、片中插入广告、暂停弹窗广告等任何形式的商业推广内容都不会出现。',
                  },
                  {
                    q: '需要什么样的设备才能观看4K视频？',
                    a: '需要支持4K分辨率的显示设备（4K电视或显示器）和至少25Mbps的稳定网络带宽。您也可以手动切换到1080P画质以适应网络条件。',
                  },
                  {
                    q: '视频资源多久更新一次？',
                    a: '我们每日更新视频资源，新片、热片持续上线。您可以通过"最新上线"板块查看每日新增内容。',
                  },
                  {
                    q: '如何搜索想看的视频？',
                    a: '点击页面右上角的搜索图标，输入关键词即可搜索。您也可以按分类浏览，每个品牌频道和类型分类下都有丰富的内容。',
                  },
                ].map((faq, idx) => (
                  <details
                    key={idx}
                    className="group rounded-xl bg-background-100 border border-background-200/50 overflow-hidden cursor-pointer"
                  >
                    <summary className="flex items-center justify-between p-5 text-sm font-medium text-foreground-100 list-none">
                      {faq.q}
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-5 pb-5 text-sm text-foreground-400 leading-relaxed">
                      {faq.a}
                    </div>
                  </details>
                ))}
              </div>
            </section>

            {/* Contact */}
            <section id="contact">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-100 mb-6">
                联系我们
              </h2>
              <div className="p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/50">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10 shrink-0">
                      <i className="ri-mail-line text-lg text-accent-500"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-100 mb-1">电子邮箱</h4>
                      <p className="text-sm text-foreground-400">contact@51video.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10 shrink-0">
                      <i className="ri-customer-service-2-line text-lg text-accent-500"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-100 mb-1">客服热线</h4>
                      <p className="text-sm text-foreground-400">400-888-5151</p>
                      <p className="text-xs text-foreground-500 mt-0.5">工作日 9:00-18:00</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10 shrink-0">
                      <i className="ri-map-pin-line text-lg text-accent-500"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-100 mb-1">公司地址</h4>
                      <p className="text-sm text-foreground-400">北京市朝阳区望京科技园</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />

      {/* Schema.org */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于51视频 - 蓝光4K超清无广告不缓冲免费在线观看',
            description: '51视频品牌介绍、核心优势、用户口碑和联系方式。蓝光4K超清画质，无广告不缓冲，免费在线观看。',
            url: 'https://51video.com/about',
            isPartOf: { '@type': 'WebSite', name: '51视频', url: 'https://51video.com/' },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              { '@type': 'Question', name: '51视频真的完全免费吗？', acceptedAnswer: { '@type': 'Answer', text: '是的，51视频所有内容完全免费，无需注册，无需会员，打开即可观看。' } },
              { '@type': 'Question', name: '真的没有任何广告吗？', acceptedAnswer: { '@type': 'Answer', text: '我们承诺全程无广告，包括片头广告、片中插入广告、暂停弹窗广告等任何形式的商业推广内容都不会出现。' } },
              { '@type': 'Question', name: '需要什么样的设备才能观看4K视频？', acceptedAnswer: { '@type': 'Answer', text: '需要支持4K分辨率的显示设备（4K电视或显示器）和至少25Mbps的稳定网络带宽。' } },
              { '@type': 'Question', name: '视频资源多久更新一次？', acceptedAnswer: { '@type': 'Answer', text: '我们每日更新视频资源，新片、热片持续上线。' } },
              { '@type': 'Question', name: '如何搜索想看的视频？', acceptedAnswer: { '@type': 'Answer', text: '点击页面右上角的搜索图标，输入关键词即可搜索。您也可以按分类浏览。' } },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://51video.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们' },
            ],
          }),
        }}
      />
    </>
  );
}